import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { formatDate } from '../../../Table'

export function getViewingOutcomeRecordLabel({ locale, outcome, t, timezone }) {
  const recordedAt = formatDate({
    date: outcome.recorded_at,
    dateFormat: DATE_SHORT_FORMAT,
    locale,
    timezone,
    useTodayFormat: false,
  })

  return outcome.recorded_by
    ? t('RentalPortal.ViewingProfileOutcomeRecordByKey', {
        date: recordedAt,
        user: outcome.recorded_by,
      })
    : t('RentalPortal.ViewingProfileOutcomeRecordKey', { date: recordedAt })
}
